/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as GuestRouteImport } from './routes/_guest'
import { Route as SignOutRouteImport } from './routes/sign-out'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedAccountRouteRouteImport } from './routes/_authenticated/account/route'
import { Route as GuestEnterCodeRouteImport } from './routes/_guest/enter-code'
import { Route as GuestForgotPasswordRouteImport } from './routes/_guest/forgot-password'
import { Route as GuestResetPasswordRouteImport } from './routes/_guest/reset-password'
import { Route as GuestSignInRouteImport } from './routes/_guest/sign-in'
import { Route as AuthenticatedAccountIndexRouteImport } from './routes/_authenticated/account/index'
import { Route as AuthenticatedAccountPasskeysRouteImport } from './routes/_authenticated/account/passkeys'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const GuestRoute = GuestRouteImport.update({
  id: '/_guest',
  getParentRoute: () => rootRouteImport,
} as any)
const SignOutRoute = SignOutRouteImport.update({
  id: '/sign-out',
  path: '/sign-out',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountRouteRoute =
  AuthenticatedAccountRouteRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const GuestEnterCodeRoute = GuestEnterCodeRouteImport.update({
  id: '/enter-code',
  path: '/enter-code',
  getParentRoute: () => GuestRoute,
} as any)
const GuestForgotPasswordRoute = GuestForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => GuestRoute,
} as any)
const GuestResetPasswordRoute = GuestResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => GuestRoute,
} as any)
const GuestSignInRoute = GuestSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => GuestRoute,
} as any)
const AuthenticatedAccountIndexRoute =
  AuthenticatedAccountIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)
const AuthenticatedAccountPasskeysRoute =
  AuthenticatedAccountPasskeysRouteImport.update({
    id: '/passkeys',
    path: '/passkeys',
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/sign-out': typeof SignOutRoute
  '/account': typeof AuthenticatedAccountRouteRouteWithChildren
  '/enter-code': typeof GuestEnterCodeRoute
  '/forgot-password': typeof GuestForgotPasswordRoute
  '/reset-password': typeof GuestResetPasswordRoute
  '/sign-in': typeof GuestSignInRoute
  '/account/passkeys': typeof AuthenticatedAccountPasskeysRoute
  '/account/': typeof AuthenticatedAccountIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/sign-out': typeof SignOutRoute
  '/enter-code': typeof GuestEnterCodeRoute
  '/forgot-password': typeof GuestForgotPasswordRoute
  '/reset-password': typeof GuestResetPasswordRoute
  '/sign-in': typeof GuestSignInRoute
  '/account/passkeys': typeof AuthenticatedAccountPasskeysRoute
  '/account': typeof AuthenticatedAccountIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_guest': typeof GuestRouteWithChildren
  '/sign-out': typeof SignOutRoute
  '/_authenticated/account': typeof AuthenticatedAccountRouteRouteWithChildren
  '/_guest/enter-code': typeof GuestEnterCodeRoute
  '/_guest/forgot-password': typeof GuestForgotPasswordRoute
  '/_guest/reset-password': typeof GuestResetPasswordRoute
  '/_guest/sign-in': typeof GuestSignInRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/account/passkeys': typeof AuthenticatedAccountPasskeysRoute
  '/_authenticated/account/': typeof AuthenticatedAccountIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-out'
    | '/account'
    | '/enter-code'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/account/passkeys'
    | '/account/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sign-out'
    | '/enter-code'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/account/passkeys'
    | '/account'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_guest'
    | '/sign-out'
    | '/_authenticated/account'
    | '/_guest/enter-code'
    | '/_guest/forgot-password'
    | '/_guest/reset-password'
    | '/_guest/sign-in'
    | '/_authenticated/'
    | '/_authenticated/account/passkeys'
    | '/_authenticated/account/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  GuestRoute: typeof GuestRouteWithChildren
  SignOutRoute: typeof SignOutRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_guest': {
      id: '/_guest'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof GuestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-out': {
      id: '/sign-out'
      path: '/sign-out'
      fullPath: '/sign-out'
      preLoaderRoute: typeof SignOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account': {
      id: '/_authenticated/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_guest/enter-code': {
      id: '/_guest/enter-code'
      path: '/enter-code'
      fullPath: '/enter-code'
      preLoaderRoute: typeof GuestEnterCodeRouteImport
      parentRoute: typeof GuestRoute
    }
    '/_guest/forgot-password': {
      id: '/_guest/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof GuestForgotPasswordRouteImport
      parentRoute: typeof GuestRoute
    }
    '/_guest/reset-password': {
      id: '/_guest/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof GuestResetPasswordRouteImport
      parentRoute: typeof GuestRoute
    }
    '/_guest/sign-in': {
      id: '/_guest/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof GuestSignInRouteImport
      parentRoute: typeof GuestRoute
    }
    '/_authenticated/account/': {
      id: '/_authenticated/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AuthenticatedAccountIndexRouteImport
      parentRoute: typeof AuthenticatedAccountRouteRoute
    }
    '/_authenticated/account/passkeys': {
      id: '/_authenticated/account/passkeys'
      path: '/passkeys'
      fullPath: '/account/passkeys'
      preLoaderRoute: typeof AuthenticatedAccountPasskeysRouteImport
      parentRoute: typeof AuthenticatedAccountRouteRoute
    }
  }
}

interface AuthenticatedAccountRouteRouteChildren {
  AuthenticatedAccountPasskeysRoute: typeof AuthenticatedAccountPasskeysRoute
  AuthenticatedAccountIndexRoute: typeof AuthenticatedAccountIndexRoute
}

const AuthenticatedAccountRouteRouteChildren: AuthenticatedAccountRouteRouteChildren =
  {
    AuthenticatedAccountPasskeysRoute: AuthenticatedAccountPasskeysRoute,
    AuthenticatedAccountIndexRoute: AuthenticatedAccountIndexRoute,
  }

const AuthenticatedAccountRouteRouteWithChildren =
  AuthenticatedAccountRouteRoute._addFileChildren(
    AuthenticatedAccountRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAccountRouteRoute: typeof AuthenticatedAccountRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccountRouteRoute: AuthenticatedAccountRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface GuestRouteChildren {
  GuestEnterCodeRoute: typeof GuestEnterCodeRoute
  GuestForgotPasswordRoute: typeof GuestForgotPasswordRoute
  GuestResetPasswordRoute: typeof GuestResetPasswordRoute
  GuestSignInRoute: typeof GuestSignInRoute
}

const GuestRouteChildren: GuestRouteChildren = {
  GuestEnterCodeRoute: GuestEnterCodeRoute,
  GuestForgotPasswordRoute: GuestForgotPasswordRoute,
  GuestResetPasswordRoute: GuestResetPasswordRoute,
  GuestSignInRoute: GuestSignInRoute,
}

const GuestRouteWithChildren = GuestRoute._addFileChildren(GuestRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  GuestRoute: GuestRouteWithChildren,
  SignOutRoute: SignOutRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
